export default class Bank {
  constructor({
    idApplication: id,
    parameters: { text: title, image: imageUrl, isVisible, link, hint, name },
  }) {
    this.id = id;
    this.title = title;
    this.img = imageUrl;
    this.isVisible = isVisible;
    //todo: хочу убрать
    this.link = link;
    this.hint = hint;
    this.name = name;
  }
}
